export default "__VITE_ASSET__d27a8fce__"